module.exports = __webpack_public_path__ + "img/p6486.cd8752f3.png";